import { css } from 'styled-components';
import {
  Color,
  BorderRadius,
  Height,
  Margin,
  Padding,
  Width,
  Gap,
} from '../types';

export const applyBorderRadius = <P extends { $borderRadius?: BorderRadius }>(
  p: P,
) =>
  p.$borderRadius &&
  css`
    border-radius: ${p.$borderRadius};
  `;

export const applyPadding = <P extends { padding?: Padding }>(p: P) =>
  p.padding !== undefined &&
  css`
    padding: ${p.padding}px;
  `;

export const applyGap = <P extends { gap?: Gap }>(p: P) =>
  p.gap !== undefined &&
  css`
    gap: ${p.gap}px;
  `;

export const applyMinHeight = <P extends { minHeight?: Height }>(p: P) =>
  p.minHeight !== undefined &&
  css`
    min-height: ${p.minHeight};
  `;

export const applyMaxHeight = <P extends { maxHeight?: Height }>(p: P) =>
  p.maxHeight !== undefined &&
  css`
    max-height: ${p.maxHeight};
  `;

export const applyHeight = <P extends { $height?: Height }>(p: P) =>
  p.$height !== undefined &&
  css`
    height: ${p.$height};
  `;

export const applyWidth = <P extends { $width?: Width }>(p: P) =>
  p.$width !== undefined &&
  css`
    width: ${p.$width};
  `;

export const applyMargin = <P extends { $margin?: Margin }>(p: P) =>
  p.$margin !== undefined &&
  css`
    margin: ${p.$margin};
  `;

export const applyBackgroundColor = <P extends { $backgroundColor?: Color }>(
  p: P,
) =>
  p.$backgroundColor &&
  css`
    background-color: ${p.$backgroundColor};
  `;

export const applyColor = <P extends { $color?: Color }>(p: P) =>
  p.$color &&
  css`
    color: ${p.$color};
  `;
